import { Get } from "@/axios/AxiosFunctions";
import PopperComponent from "@/components/Core/PopperComponent";
import Statuses from "@/components/Core/Statuses";
import TableStructure from "@/components/Core/TableStructure";
import { BaseURL } from "@/config/apiUrl";
import { recordsLimit } from "@/constant/constants";
import { requestEditTableHeaders } from "@/data/data";
import {
  formatDateTime,
} from "@/helper/HelperFunction";
import { useEffect, useState } from "react";
import { FaRegEye } from "react-icons/fa6";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import classes from "./RequestEditTable.module.css";

const LOADING_STATES = {
  GET_ALL: "getAll",
};

const RequestEditTable = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { access_token } = useSelector((state) => state.authReducer);
  const [page, setPage] = useState(1);
  const [totalRecord, setTotalRecord] = useState(0);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(null);

  const handleUserAction = (action, item) => {
    if (!action || !action.value) return;
    switch (action.value) {
      case "view":
        navigate(`/request-edits/${item?.post}/${item?._id}`);
        break;
      default:
        console.warn(`Unknown action: ${action.value}`);
    }
  };
  //   get request edit
  const getRequestEdits = async (pgNo = page) => {
    const url = BaseURL(
      `admin/posts/find-edits/${id}?page=${pgNo}&limit=${recordsLimit}`
    );
    setLoading(LOADING_STATES.GET_REQUEST_EDITS);
    const response = await Get(url, access_token);
    if (response) {
      setData(response?.data?.edits);
      setTotalRecord(response?.data?.totalCount);
    }
    setLoading(null);
  };

  useEffect(() => {
    getRequestEdits(1);
  }, []);
  return (
    <div className={classes.users}>
      <TableStructure
        headerTitle={""}
        tableContent={data?.map((item) => ({
          ...item,
          fullName: item?.user?.fullName || "-",
          createdAt: formatDateTime(item?.createdAt),
          status: <Statuses status={item?.status} />,
          actions: (
            <PopperComponent
              data={getPopperOptions(item)}
              handleClick={(action) => handleUserAction(action, item)}
            />
          ),
        }))}
        tableHeaders={requestEditTableHeaders}
        tableType="secondary"
        page={page}
        setPage={(page) => {
          setPage(page);
          getRequestEdits(page);
        }}
        isLoading={loading === LOADING_STATES.GET_REQUEST_EDITS}
        totalRecord={totalRecord}
        recordLimit={recordsLimit}
        noDataMessage="No request edits found"
        showPagination={true}
        customStyle={{
          height: "calc(100vh - 320px)",
        }}
      />
    </div>
  );
};

export default RequestEditTable;

const getPopperOptions = (item) => {
  const options = [{ icon: <FaRegEye />, label: "View", value: "view" }];

  return options;
};
